function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "credit-card");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.501650856
}, /*#__PURE__*/React.createElement("g", {
  id: "Paid-Profile",
  transform: "translate(-503.000000, -204.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(164.000000, 182.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(309.000000, 17.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "credit-card",
  transform: "translate(28.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bound",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("rect", {
  id: "Combined-Shape",
  fill: "#000000",
  fillRule: "nonzero",
  opacity: 0.3,
  x: 2,
  y: 5,
  width: 20,
  height: 14,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-59",
  fill: "#000000",
  fillRule: "nonzero",
  x: 2,
  y: 8,
  width: 20,
  height: 3,
  className: "active-rect"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-59-Copy",
  fill: "#000000",
  fillRule: "nonzero",
  opacity: 0.3,
  x: 16,
  y: 14,
  width: 4,
  height: 2,
  rx: 1
}))))));

var SvgPaidProfileCreditCard = function SvgPaidProfileCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "14px",
    viewBox: "0 0 20 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaidProfileCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paid-profile-credit-card.b7079a95.svg";
export { ForwardRef as ReactComponent };